// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layers-layer-title {\n    font-size: 16px;\n    padding-left: 5px;\n    padding-top: 5px;\n}\n\n.layers-layer-icon {\n    max-height: 32px;\n}\n", ""]);
// Exports
module.exports = exports;
